import { render, staticRenderFns } from "./innerWordChange.vue?vue&type=template&id=79abcfa3&scoped=true&"
import script from "./innerWordChange.vue?vue&type=script&lang=js&"
export * from "./innerWordChange.vue?vue&type=script&lang=js&"
import style0 from "./innerWordChange.vue?vue&type=style&index=0&id=79abcfa3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79abcfa3",
  null
  
)

export default component.exports